import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "noveocard_consent";

// Bannière cookies conforme : refuser est aussi simple qu'accepter,
// et aucun script de mesure d'audience ne se charge avant le consentement.
export default function CookieBanner() {
  const [choice, setChoice] = useState(null);

  useEffect(() => {
    try {
      setChoice(localStorage.getItem(KEY) || "pending");
    } catch {
      setChoice("pending");
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      /* stockage indisponible : choix appliqué pour la session */
    }
    if (value === "accepted" && process.env.REACT_APP_PLAUSIBLE_DOMAIN) {
      const s = document.createElement("script");
      s.defer = true;
      s.dataset.domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
      s.src = "https://plausible.io/js/script.js";
      document.head.appendChild(s);
    }
    setChoice(value);
  };

  return (
    <AnimatePresence>
      {choice === "pending" && (
        <motion.div
          className="fixed inset-x-0 bottom-0 z-[70] p-4 sm:p-6"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          role="dialog"
          aria-live="polite"
          aria-label="Bandeau de consentement cookies"
          data-testid="cookie-banner"
        >
          <div className="mx-auto max-w-3xl rounded-3xl border border-nuit-900/10 bg-white/95 p-5 shadow-[0_24px_60px_-20px_rgba(7,26,45,0.35)] backdrop-blur-xl sm:p-6">
            <p className="font-display text-base font-semibold text-nuit-900">Respect de votre vie privée</p>
            <p className="mt-1.5 text-sm leading-relaxed text-steel">
              Nous n'utilisons aucun cookie publicitaire. Une mesure d'audience anonyme et respectueuse
              peut être activée uniquement avec votre accord.{" "}
              <Link to="/politique-cookies" className="font-medium text-electric underline-offset-2 hover:underline">
                En savoir plus
              </Link>
            </p>
            <div className="mt-4 flex flex-col gap-2.5 sm:flex-row">
              <button
                onClick={() => decide("refused")}
                data-testid="cookie-refuse-btn"
                className="flex-1 rounded-full border border-nuit-900/20 px-5 py-3 font-display text-sm font-semibold text-nuit-900 transition-colors hover:border-nuit-900/60"
              >
                Tout refuser
              </button>
              <button
                onClick={() => decide("accepted")}
                data-testid="cookie-accept-btn"
                className="flex-1 rounded-full bg-electric px-5 py-3 font-display text-sm font-semibold text-white transition-colors hover:bg-electric-600"
              >
                Tout accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
